/**
 * Surcharges API Mutations
 *
 * Write operations.
 */

import { apiClient } from '../client';
import type { CalculationType } from '../calculationType';
import type { Surcharge } from './types';

export interface CreateSurchargePayload {
  name: string;
  amount: string;
  calculation_type: CalculationType;
}

export interface UpdateSurchargePayload {
  name: string;
  amount: string;
  calculation_type: CalculationType;
  description?: string | null;
}

export interface SurchargeResponse {
  surcharge: Surcharge;
}

export async function createSurcharge(payload: CreateSurchargePayload): Promise<SurchargeResponse> {
  const { data } = await apiClient.post<SurchargeResponse>('/api/surcharges', { surcharge: payload });
  return data;
}

export async function updateSurcharge(id: number, payload: UpdateSurchargePayload): Promise<SurchargeResponse> {
  const { data } = await apiClient.patch<SurchargeResponse>(`/api/surcharges/${id}`, { surcharge: payload });
  return data;
}

export async function deleteSurcharge(id: number): Promise<void> {
  await apiClient.delete<void>(`/api/surcharges/${id}`);
}
